/**
 * IMPORTANT: Do not use route() or localizedRoute() in this file as this breaks SSR.
 *
 * The ErrorPage is rendered without the HandleInertiaRequest middleware and therefore
 * Ziggy routes are not available.
 */

import Logo from '../../img/logo.svg';

import { PropsWithChildren } from 'react';
import { UI } from '@/Components/UI';

type GuestLayoutProps = PropsWithChildren<{
    title?: string;
    description?: string;
}>

export const GuestLayout = ({ title, description, children }: GuestLayoutProps) => {
    return (
        <section className={'min-h-screen px-5 py-16 flex flex-col items-center bg-surface-2'}>
            <div className={'flex flex-col items-center max-w-lg w-full grow'}>
                <div
                    className={'size-16 bg-primary/40'}
                    style={{ mask: `url(${Logo}) no-repeat center / contain` }} />

                <span className={'text-primary/40 text-4xl font-baloo font-semibold'}>
                    {import.meta.env.VITE_APP_NAME}
                </span>

                <div className={'block w-full mt-16 p-6 rounded-xl shadow-sm text-on-background bg-background'}>
                    {title && (
                        <UI.Heading
                            level={1}
                            className={'mt-0 text-center'}>
                            {title}
                        </UI.Heading>
                    )}

                    {description && (
                        <p className={'text-center text-on-surface-variant'}>
                            {description}
                        </p>
                    )}

                    {children && (
                        <div className={'mt-4'}>
                            {children}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};
